import { render, staticRenderFns } from "./order-history-modal.vue?vue&type=template&id=2e6cbacb&scoped=true&"
import script from "./order-history-modal.js?vue&type=script&lang=js&"
export * from "./order-history-modal.js?vue&type=script&lang=js&"
import style0 from "./order-history-modal.scss?vue&type=style&index=0&id=2e6cbacb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cbacb",
  null
  
)

export default component.exports